import styled, { css, keyframes } from 'styled-components';
import { Wrapper } from 'AppReact';

export const grow = keyframes`
  0% {
    width: 0px;
    overflow: hidden;
  }
  100% {
    width: 230px;
    overflow: unset;
  }
`;

const template = styled.div`
  ${({ displayState }) => css`
    left: 0px;
    top: 0px;
    width: 0px;
    overflow: hidden;
    z-index: 10;

    ${displayState.isOpen && css`
      animation: ${grow} 1s ease-in-out 0s forwards;  
    `}
  `}
`;

export default Wrapper(template)